import LegalCard from './legalCard'

export default LegalCard
